import { render, staticRenderFns } from "./HelpCenterFaqs.vue?vue&type=template&id=3d173dfc&scoped=true"
import script from "./HelpCenterFaqs.vue?vue&type=script&lang=ts"
export * from "./HelpCenterFaqs.vue?vue&type=script&lang=ts"
import style0 from "./HelpCenterFaqs.vue?vue&type=style&index=0&id=3d173dfc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d173dfc",
  null
  
)

export default component.exports